'use strict';

var _each2 = _interopRequireDefault(require("lodash/each"));

var _isPlainObject2 = _interopRequireDefault(require("lodash/isPlainObject"));

var _isArray2 = _interopRequireDefault(require("lodash/isArray"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = function (schema) {
  var _this = this;

  if ((0, _isArray2.default)(schema)) {
    schema = schema[0];
  }

  if (!(0, _isPlainObject2.default)(schema)) return null;

  if (!schema.$) {
    schema.$ = {};
  }

  if (schema.$.primary === undefined) {
    (0, _each2.default)(schema, function (value, key) {
      if (value instanceof _this.classes.Type && value.primary) {
        schema.$.primary = key;
        return false;
      }
    });

    if (schema.$.primary === undefined) {
      schema.$.primary = null;
    }
  }

  return schema.$.primary;
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NvdXJjZS9zeXN0ZW0vc2NoZW1hUHJpbWFyeS5qcyJdLCJuYW1lcyI6WyJtb2R1bGUiLCJleHBvcnRzIiwic2NoZW1hIiwiJCIsInByaW1hcnkiLCJ1bmRlZmluZWQiLCJ2YWx1ZSIsImtleSIsImNsYXNzZXMiLCJUeXBlIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7OztBQUlBQSxPQUFPQyxPQUFQLEdBQWlCLFVBQVVDLE1BQVYsRUFBbUI7QUFBQTs7QUFFbkMsTUFBSyx1QkFBV0EsTUFBWCxDQUFMLEVBQTJCO0FBRTFCQSxhQUFTQSxPQUFRLENBQVIsQ0FBVDtBQUVBOztBQUVELE1BQUssQ0FBQyw2QkFBaUJBLE1BQWpCLENBQU4sRUFBa0MsT0FBTyxJQUFQOztBQUVsQyxNQUFLLENBQUNBLE9BQU9DLENBQWIsRUFBaUI7QUFFaEJELFdBQU9DLENBQVAsR0FBVyxFQUFYO0FBRUE7O0FBRUQsTUFBS0QsT0FBT0MsQ0FBUCxDQUFTQyxPQUFULEtBQXFCQyxTQUExQixFQUFzQztBQUVyQyx3QkFBUUgsTUFBUixFQUFnQixVQUFFSSxLQUFGLEVBQVNDLEdBQVQsRUFBa0I7QUFFakMsVUFBS0QsaUJBQWlCLE1BQUtFLE9BQUwsQ0FBYUMsSUFBOUIsSUFBc0NILE1BQU1GLE9BQWpELEVBQTJEO0FBRTFERixlQUFPQyxDQUFQLENBQVNDLE9BQVQsR0FBbUJHLEdBQW5CO0FBQ0EsZUFBTyxLQUFQO0FBRUE7QUFFRCxLQVREOztBQVdBLFFBQUtMLE9BQU9DLENBQVAsQ0FBU0MsT0FBVCxLQUFxQkMsU0FBMUIsRUFBc0M7QUFFckNILGFBQU9DLENBQVAsQ0FBU0MsT0FBVCxHQUFtQixJQUFuQjtBQUVBO0FBRUQ7O0FBRUQsU0FBT0YsT0FBT0MsQ0FBUCxDQUFTQyxPQUFoQjtBQUVBLENBdkNEIiwic291cmNlc0NvbnRlbnQiOlsiJ3VzZSBzdHJpY3QnO1xuXG5pbXBvcnQgXyBmcm9tICdsb2Rhc2gnO1xuXG5tb2R1bGUuZXhwb3J0cyA9IGZ1bmN0aW9uKCBzY2hlbWEgKSB7XG5cblx0aWYgKCBfLmlzQXJyYXkoIHNjaGVtYSApICkge1xuXG5cdFx0c2NoZW1hID0gc2NoZW1hWyAwIF07XG5cblx0fVxuXG5cdGlmICggIV8uaXNQbGFpbk9iamVjdCggc2NoZW1hICkgKSByZXR1cm4gbnVsbDtcblxuXHRpZiAoICFzY2hlbWEuJCApIHtcblxuXHRcdHNjaGVtYS4kID0ge307XG5cblx0fVxuXG5cdGlmICggc2NoZW1hLiQucHJpbWFyeSA9PT0gdW5kZWZpbmVkICkge1xuXG5cdFx0Xy5lYWNoKCBzY2hlbWEsICggdmFsdWUsIGtleSApID0+IHtcblxuXHRcdFx0aWYgKCB2YWx1ZSBpbnN0YW5jZW9mIHRoaXMuY2xhc3Nlcy5UeXBlICYmIHZhbHVlLnByaW1hcnkgKSB7XG5cblx0XHRcdFx0c2NoZW1hLiQucHJpbWFyeSA9IGtleTtcblx0XHRcdFx0cmV0dXJuIGZhbHNlO1xuXG5cdFx0XHR9XG5cblx0XHR9ICk7XG5cblx0XHRpZiAoIHNjaGVtYS4kLnByaW1hcnkgPT09IHVuZGVmaW5lZCApIHtcblxuXHRcdFx0c2NoZW1hLiQucHJpbWFyeSA9IG51bGw7XG5cblx0XHR9XG5cblx0fVxuXG5cdHJldHVybiBzY2hlbWEuJC5wcmltYXJ5O1xuXG59OyJdfQ==